import React from "react";
import {
	addTimeToDate,
	Button,
	Conditional,
	dateTrunc,
	Else,
	If,
	Modal,
	Row,
	toLocalDateString,
} from "@hex-insights/core";
import { Icon } from "../../../../../../Components/Icon";
import { StudentDetailQuery, useStudentSchoolAttendanceRecordsQuery } from "../../../../../../Utilities";
import { AttendanceStatusFormat } from "../../../../../Format";
import { SchoolAttendanceRecordStudentDateModal } from "../../../../SchoolAttendanceRecord";

export type StudentAttendanceStatusProps = {
	student: StudentDetailQuery["student"];
};

export function StudentAttendanceStatus({ student }: StudentAttendanceStatusProps) {
	const today = new Date();
	const dayStart = dateTrunc(today, "day");
	const dayEnd = addTimeToDate(dayStart, [1, "day"]);
	const { loading, data } = useStudentSchoolAttendanceRecordsQuery({
		variables: {
			filters: { studentIDEQ: student.id, createdAtGTE: dayStart.toISOString(), createdAtLT: dayEnd.toISOString() },
		},
		fetchPolicy: "cache-and-network",
	});
	const baseAttendanceRecord = data?.schoolAttendanceRecordConnection.edges[0]?.node ?? null;
	const attendanceRecord = React.useMemo(() => {
		if (!baseAttendanceRecord) {
			return null;
		}
		return { ...baseAttendanceRecord, student };
	}, [student, baseAttendanceRecord]);

	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<React.Fragment>
			<Button onClick={openModal} style={{ padding: 0, border: "none" }} disabled={loading}>
				<Row
					justify="spaced-start"
					align="center"
					horizontalSpacing="0.375rem"
					style={{ color: "var(--brand-colors--primary)", fontWeight: "bold" }}
				>
					<Conditional>
						<If condition={!attendanceRecord}>
							<Icon.IdentificationCard size={16} /> No Attendance
						</If>
						<Else>
							{!!attendanceRecord && (
								<React.Fragment>
									<Icon.IdentificationCard size={16} />{" "}
									{AttendanceStatusFormat.status(attendanceRecord.attendanceStatus)}
								</React.Fragment>
							)}
						</Else>
					</Conditional>
				</Row>
			</Button>

			<Modal.If condition={isModalOpen}>
				<SchoolAttendanceRecordStudentDateModal
					student={student}
					date={toLocalDateString(today)}
					schoolAttendanceRecord={attendanceRecord}
					onClose={closeModal}
				/>
			</Modal.If>
		</React.Fragment>
	);
}
